import React, { useState, useContext } from "react";
import './EmpresaSelect.css';

import AutoComplete from "@components/AutoComplete";
import UserContext from "@components/context/userContext";
import empresasService from "@services/empresas";


const setCookie = (name, value, days) => {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/; domain=.eposgestofinal.com";
}

const EmpresaSelect = ({ onLogin, cookies }) => {
    const profile = useContext(UserContext);
    const [empresa, setEmpresa] = useState();
    const [empresas, setEmpresas] = useState([]);
    const [loaded, setLoaded] = useState(false);
    const [isChanging, setIsChanging] = useState(false);
    
    if (profile['memberType'] <= 9) {
        return null;
    }

    const loadFunction = async () => {
        if (!loaded) {
            setLoaded(true);
            try {
                const empresasResp = await empresasService.get();
                const hydratateEmpresasResp = empresasResp.map((empresaResp) => ({
                    ...empresaResp,
                    value: empresaResp.idempresa,
                    label: empresaResp.nomeempresa,
                }));
                setEmpresas(hydratateEmpresasResp);
                setEmpresa(hydratateEmpresasResp.find((empresaResp) => 
                    `${empresaResp.idempresa}` === `${(profile.idEmpresaSec)}`
                ));
            } catch (error) {
                console.error(error);
            }
        }
    };

    loadFunction();

    const handleChange = (e) => {
        let value = e.target.value;
        setIsChanging(true);
        setEmpresa(value.idempresa);
        setCookie("member_idempresa_sec", value.idempresa);
        setTimeout(() => {
            window.location.reload();
        }, 300);
    }

    return (
        <div className="empresa-select-container">
            <div className="empresa-select-card">
                <div className="empresa-select-admin-badge">
                    <svg 
                        width="14" 
                        height="14" 
                        viewBox="0 0 24 24" 
                        fill="none" 
                        stroke="currentColor" 
                        strokeWidth="2"
                    >
                        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
                    </svg>
                    Acesso Administrativo
                </div>
                
                <div className="empresa-select-main-content">
                    <div className="empresa-select-left">
                        <div className="empresa-select-icon">
                            <svg 
                                width="24" 
                                height="24" 
                                viewBox="0 0 24 24" 
                                fill="none" 
                                stroke="currentColor" 
                                strokeWidth="2" 
                                strokeLinecap="round" 
                                strokeLinejoin="round"
                            >
                                <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                                <polyline points="9 22 9 12 15 12 15 22"></polyline>
                            </svg>
                        </div>
                        <div className="empresa-select-text">
                            <h3 className="empresa-select-title">Selecione a Empresa</h3>
                            <p className="empresa-select-subtitle">
                                Escolha a empresa que deseja gerir
                            </p>
                        </div>
                    </div>
                    
                    <div className={`empresa-select-right ${isChanging ? 'changing' : ''}`}>
                        <div className="empresa-select-field">
                            <label className="empresa-select-label">
                                <svg 
                                    width="16" 
                                    height="16" 
                                    viewBox="0 0 24 24" 
                                    fill="none" 
                                    stroke="currentColor" 
                                    strokeWidth="2"
                                >
                                    <rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect>
                                    <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path>
                                </svg>
                                Empresa
                            </label>
                            <div className="empresa-select-input-wrapper">
                                <AutoComplete
                                    name={"empresa"}
                                    value={empresa}
                                    handleChange={handleChange}
                                    options={empresas}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                
                {isChanging && (
                    <div className="empresa-select-loading">
                        <div className="empresa-select-spinner"></div>
                        <span>A carregar empresa...</span>
                    </div>
                )}
                
                <div className="empresa-select-footer">
                    <svg 
                        width="14" 
                        height="14" 
                        viewBox="0 0 24 24" 
                        fill="none" 
                        stroke="currentColor" 
                        strokeWidth="2"
                    >
                        <circle cx="12" cy="12" r="10"></circle>
                        <line x1="12" y1="16" x2="12" y2="12"></line>
                        <line x1="12" y1="8" x2="12.01" y2="8"></line>
                    </svg>
                    <span>Funcionalidade exclusiva para administradores • A alteração será aplicada imediatamente</span>
                </div>
            </div>
        </div>
    );
};

export default EmpresaSelect;
